import {DateTimeFormat} from 'platform/locale';
import {DeepReadonly} from 'utility-types';

import {isNil} from 'ramda';

import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {Nullish, parseDate} from 'shared/web';

interface PlatformDateProps {
  platformCode: string;
  updatedAt?: string | Nullish;
}

export const PlatformDate = ({platformCode, updatedAt}: DeepReadonly<PlatformDateProps>) => {
  if (isNil(updatedAt)) {
    return EMPTY_PLACEHOLDER;
  }

  return (
    <DateTimeFormat
      value={parseDate(updatedAt)}
      format="dateTimeShort"
      data-testid={`date-advertisement-platforms-${platformCode}`}
    />
  );
};
